import React from 'react';
import Sym from './Sym';

const ICONS = { info: 'info', ok: 'task_alt', warn: 'warning', danger: 'error' };
const COLORS = {
  info: 'var(--brand-2)', ok: 'var(--ok)', warn: 'var(--warn)', danger: 'var(--danger)',
};

/**
 * Aviso en línea (banner de límite de plan, nota de la e.firma, resultado de una
 * sincronización…).
 *
 * @param {'info'|'ok'|'warn'|'danger'} tone
 * @param {node} action  botón opcional a la derecha
 */
const Note = ({ tone = 'info', icon, action, className = '', children, ...rest }) => (
  <div
    className={[
      'a2-note',
      tone !== 'info' ? `a2-note--${tone}` : '',
      className,
    ].filter(Boolean).join(' ')}
    {...rest}
  >
    <Sym
      name={icon || ICONS[tone]}
      size={22}
      style={{ color: COLORS[tone], flexShrink: 0 }}
    />
    <span style={{ flex: 1, minWidth: 0 }}>{children}</span>
    {action}
  </div>
);

export default Note;
